import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const Report = lazyWithRetry(() => import(/* webpackChunkName: "report" */'../../component/Report'))

const ReportPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<Report />
		</Suspense>
	)
})

ReportPage.displayName = 'ReportPage'
export default ReportPage
